import { Component, OnInit } from '@angular/core';
import {SettledServicesService} from '../../services/settled-services/settled-services.service';

@Component({
  selector: 'app-list-settled-services',
  templateUrl: './list-settled-services.component.html',
  styleUrls: ['./list-settled-services.component.scss']
})
export class ListSettledServicesComponent implements OnInit {

    settledServices: any;
    constructor(
      private settledServicesService: SettledServicesService
  ) { }

    ngOnInit(): void {
        const t = this;
        t.loadItems();
    }

    loadItems() {
        const t = this;
        this.settledServicesService.get().subscribe((data: any) => {
            t.settledServices = data;
        });
    }

}
